var map = {
	"./3D Render.png": 3693,
	"./Abstract.png": 3300,
	"./Afrofuturism.png": 7964,
	"./Analogue.png": 7300,
	"./Ancient.png": 4532,
	"./Anime.png": 4698,
	"./Baroque.png": 3231,
	"./Bell Jar.png": 9557,
	"./Cinematography.png": 9531,
	"./Classic.png": 5819,
	"./Colour and Line.png": 9650,
	"./Cubist.png": 2170,
	"./Cyberpunk.png": 431,
	"./Expressive.png": 3145,
	"./Fantasy.png": 5660,
	"./Impressionist.png": 4788,
	"./Intuitive.png": 6664,
	"./Kind of Blue.png": 5287,
	"./Minimalism.png": 3994,
	"./Neon Arts.png": 15,
	"./Pop Art.png": 7769,
	"./Realism.png": 995,
	"./Shanshui.png": 1599,
	"./Sketch.png": 1287,
	"./Steampunk.png": 7164,
	"./Strange.png": 8864,
	"./Studio Light.png": 8624,
	"./Watercolour.png": 3577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2772;